/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import device from 'current-device';

$(document).ready(function() {
  // dismissable elements
  $('.js-dismiss').on('click', function(e) {
    e.preventDefault();
    $(this).parents('.js-dismissable').remove();
    if ($(this).data('persist')) {
      const hours = $(this).data('hours') || 24;
      const now = new Date();
      const expires = now.getTime() + ((3600 * hours) * 1000);
      now.setTime(expires);
      now.toUTCString();
      return document.cookie = `${$(this).data('persist')}=true; expires=${now.toUTCString()}; path=/`;
    }
  });

  // slim popup windows
  $('.js-popup').click(function(e) {
    e.preventDefault();
    return window.open($(this).attr('href'), 'mubipopup', 'width=600,height=550,menubar=0,toolbar=0,scrollbars=1,left=0,top=0');
  });

  // social buttons
  $('.social-share').on('click', '.js--open-window', function(e) {
    e.preventDefault();
    return window.open($(this).attr("href"), "", "width=655,height=430");
  });

  $('.js--close-target').on('click', function(e) {
    e.preventDefault();
    return $($(this).data('target')).remove();
  });

  // non-modal subscripton plan selection
  $('.js--select-plan').click(function() {
    $('.js--select-plan').removeClass('-selected');
    $(this).addClass('-selected');
    return $('.js--input-renewal-period').val($(this).data('renewal-period'));
  });

  $('.js--friendly-ts').friendlyTimestamp();

  // consumed in views/search/results.js for nano scroller
  $('html').attr('data-height', $(window).height());

  // although vh units are widely supported, there are still issues on
  // ios. more detail here:
  // https://nicolas-hoizey.com/2015/02/viewport-height-is-taller-than-the-visible-part-of-the-document-in-some-mobile-browsers.html
  if (!window.Modernizr.cssvhunit && !device.iphone()) {
    const height = $(window).height();
    $('.js--100vh').css('height', height);
    $('.js--min-100vh').css('min-height', height);
  }

  return $('.js-action-button').progressButton();
});
